export default __webpack_public_path__ + "static/media/Ballroll_00283.7d604c8b.png";